<script>
import ProductListDesktopView from "./ProductListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders ProductListDesktopView using the parent product-list instance as
 * context so template bindings and $refs stay on list.vue (provide/inject).
 */
export default {
  name: "ProductListDesktopBridge",
  inject: ["productList"],
  render() {
    const productList = this.productList;
    const viewOptions = ProductListDesktopView.options || ProductListDesktopView;
    const render = viewOptions.render;

    if (!productList || typeof render !== "function") {
      return null;
    }

    const options = productList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(productList, productList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
